import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Avatars, UiKits } from "../../../Constants/Constants";
import AvatarSizes from "./AvatarSizes";
import Grouping from "./Grouping";
import Ratio from "./Ratio";
import Shapes from "./Shapes";
import StatusIndicator from "./StatusIndicator";

const AvatarsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Avatars} parent={UiKits} />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <AvatarSizes />
            <StatusIndicator />
            <Shapes />
            <Ratio />
            <Grouping />
          </Row>
        </div>
      </Container>
    </>
  );
};
export default AvatarsContainer;
